import { LucideArrowUpRight, LucideChartNoAxesCombined, LucideChartPie, LucideDatabase } from "lucide-react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function About(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const cards = [
    {
      "id": 1,
      "label": "120+ pays connectés",
      "title": "Réseau global",
      "img": "https://images.pexels.com/photos/3184287/pexels-photo-3184287.jpeg?_gl=1*11b4ehr*_ga*ODcwMjA3Mzc5LjE3NzE5MjA5NDk.*_ga_8JE65Q40S6*czE3NzIwMTk1ODEkbzMkZzEkdDE3NzIwMjM2MzMkajQyJGwwJGgw",
      "text": "Accédez instantanément à des milliers d’agences réparties dans plus de 120 pays et multipliez vos opportunités commerciales.",
    },
    {
      "id": 2,
      "label": "10k+ partenaires actifs",
      "title": "Croissance accélérée",
      "img": "https://images.pexels.com/photos/8083429/pexels-photo-8083429.jpeg?_gl=1*1kftr49*_ga*ODcwMjA3Mzc5LjE3NzE5MjA5NDk.*_ga_8JE65Q40S6*czE3NzIwOTY0OTQkbzQkZzEkdDE3NzIwOTY5OTckajIwJGwwJGgw",
      "text": "Grâce à nos outils d’automatisation et reporting avancé, augmentez votre volume de ventes sans complexité opérationnelle.",
    }
  ];
  const steps = [
    {
      "id": 1,
      "title": "Créer votre espace",
      "icon": <LucideChartNoAxesCombined size={28} className="text-blue" />,
      "text": "Inscription rapide, validation sous 48h et accès immédiat à l’environnement partenaire.",
    },
    {
      "id": 2,
      "title": "Configurer votre offre",
      "icon": <LucideChartPie size={28} className="text-blue" />,
      "text": "Ajoutez vos produits (hôtels, vols, expériences, transferts) via notre interface ou API.",
    },
    {
      "id": 3,
      "title": "Optimiser et vendre",
      "icon": <LucideDatabase size={28} className="text-blue" />,
      "text": "Fixez vos marges, suivez vos performances en temps réel et bénéficiez de notre réseau d’acheteurs.",
    },
    {
      "id": 4,
      "title": "Développez-vous",
      "icon": <LucideChartNoAxesCombined size={28} className="text-blue" />,
      "text": "Accédez à des statistiques avancées et à des programmes de co-marketing pour booster votre visibilité.",
    },
  ];
  return (
    <div className="position-relative" style={{ background: "#F5F5F5" }}>
      {/* Hero Section with Background Image */}
      <img
        src="https://images.pexels.com/photos/5232601/pexels-photo-5232601.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
        alt="main bg"
        width="100%"
        style={{
          height: "70vh",
          objectFit: "cover",
          filter: "brightness(0.7)"
        }}
      />

      {/* Hero Text Overlay */}
      <div className="position-absolute w-100 h-100 top-0 start-0 text-white">
        <div className="container-xl" >
          <div className="mt-5 pt-5">
            <Row>
              <Col xl="8">
                <h1 className="mt-5" style={{ fontSize: 'clamp(2rem, 8vw, 4.5rem)' }}>{t('about_us')}</h1>
                <p className="fs-2 pb-3">{t("about_home_title")}</p>
                <button className="mt-5 btn fw-medium px-4 py-3 rounded-3"
                 onClick={() => navigate("/contact")}
                  style={{
                    background: 'rgba(255, 255, 255, 0.2)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.25)',
                    color: '#fff',
                    fontSize: '1.1rem',
                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)'
                  }}>{t('contant_title')}</button>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* Cards Section - Alternating Layout */}
      
      <div className="container-xl mt-5">
        <h2 className='fs-1' >{t("about_subtitle")}</h2>
            <p className='opacity-75'>{t('about_caption')}</p>
        {cards.map((card, index) => {
          // Alternate layout: image left for even index (first card), image right for odd index (second card)
          const isImageLeft = card.id % 2 === 0;

          return (

            <Row
              key={card.id}
              className=" my-4  align-items-center justify-content-center"
            >
              {isImageLeft ? (
                <>
                  {/* Image column on the left (first card) */}
                  <Col className="mt-4">
                    <img
                      src={card.img}
                      alt={card.title || "Card image"}
                      style={{
                        maxHeight: "370px",
                        width: "100%",
                        objectFit: "cover",
                        filter: "brightness(0.7)",
                      }}
                      className="rounded-4"
                    />
                  </Col>
                  {/* Text column on the right */}
                  <Col className="pt-4">
                    <h4 className="btn-primary text-white p-2 rounded d-inline-block">
                      {t(card.label)}
                    </h4>
                    <h1 className="text-blue pt-2 fw-bold">{t(card.title)}</h1>
                    <p className="pt-3 fw-medium fs-5">{t(card.text)}</p>
                  </Col>
                </>
              ) : (
                <>
                  {/* Text column on the left (second card) */}
                  <Col className="pt-4">
                    <h4 className="btn-primary text-white p-2 rounded d-inline-block">
                      {t(card.label)}
                    </h4>
                    <h1 className="text-blue pt-2 fw-bold">{t(card.title)}</h1>
                    <p className="pt-3 fw-medium fs-5">{t(card.text)}</p>
                  </Col>
                  {/* Image column on the right */}
                  <Col >
                    <img
                      src={card.img}
                      alt={card.title || "Card image"}
                      style={{
                        maxHeight: "370px",
                        width: "100%",
                        objectFit: "cover",
                        filter: "brightness(0.7)",
                      }}
                      className="rounded-4"
                    />
                  </Col>
                </>
              )}
            </Row>

          );
        })}
      </div>
      <div className="container-xl mt-5 pb-4" >
        <Row>
          <h1 className="fs-1">{t("easily_join_us")}<span className="text-blue"> {t("today")}</span></h1>
          <p className="fw-normal pt-1 pb-4">{t("join_us_text")}</p>
        </Row>
        <Row className=" align-items-center justify-content-center">
          {steps.map((step, idStep) => (
            <Col key={idStep} sm={5} className="border border-2 border-white border-bottom-0 rounded-5 p-4 m-3 shadow " style={{ background: "#F5F5F5" }}>
              <div className="d-flex justify-content-between align-items-center pb-4">
                <h1 className="mb-0 text-blue">{step.id}.</h1>
                {step.icon}
              </div>
              <h2 className="pb-2">{t(step.title)}</h2>
              <p>{t(step.text)}</p>
            </Col>
          ))}
        </Row>
        <div className="bg-blue rounded-5 border border-3 border-white my-4 p-5">
          <div className="row ">
            <div className="col-sm-9 ">
              {/* Texte principal */}
              <h1 className="display-4 fw-bold text-white mb-4">
                {t("success_story_title")}
              </h1>
            </div>
            {/* Bouton Join us avec effet glassmorphism */}
            <button
              className="btn col-sm-2 fw-medium px-5 py-3 rounded-4 mb-5"
              style={{
                background: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                color: 'white',
                fontSize: '1.2rem',
                letterSpacing: '0.5px',
                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)'
              }}>
              {t("join_us")}
            </button>
            <p className="text-white opacity-75 col-sm-9 fs-5" >
              {t("partners_text")}
            </p>
            <button
              className="text-white bg-transparent col-sm-2 fw-medium  py-3 rounded-4 mb-5">
              {t("book_call")} <LucideArrowUpRight />
            </button>
          </div>
          {/* Texte de description */}



        </div>
      </div>
    </div>
  );
}

export default About;